import { sourceLevel, type MyResource, type ResourceTileVm } from '@krp/platform-ui'

import { CONNECTION_FORMS } from '../../composition/connectionForms'

/** Название источника для человека — и в мини-окне «Связь», и в диагностике: «Кабинет AQSI · Вольная 28». */
export function sourceTitleOf(resource: MyResource): string {
  return `${CONNECTION_FORMS.sourceNounOf(resource.kind)} · ${resource.displayName}`
}

/** Источник не отвечает — плитка ставит красную метку (RP-UI-LINK, шаг 3); подробности — в точке «Связь». */
export function isSourceDown(resource: MyResource): boolean {
  return sourceLevel(resource.contact) === 'down'
}

/** Плитка источника: метка и слово вида — от формы подключения пакета вида, остальное — «мои ресурсы». */
export function tileOf(resource: MyResource, lines: readonly string[]): ResourceTileVm {
  return {
    id: resource.id,
    mark: CONNECTION_FORMS.shortTitleOf(resource.kind),
    noun: CONNECTION_FORMS.sourceNounOf(resource.kind),
    name: resource.displayName,
    tone: CONNECTION_FORMS.toneOf(resource.kind),
    contactDown: isSourceDown(resource),
    lines,
  }
}
